import {CheckOutlined} from '@ant-design/icons';
import parse, {domToReact} from 'html-react-parser';
import React, {useMemo} from 'react';
import {Link} from 'react-router-dom';

import {getTagInfo} from '../../../consts/notifications/notifications.js';
import NotificationCategoryIcon from '../NotificationCategoryIcon';

const MobileNotificationItem = ({item, onMarkAsRead}) => {
    const {name: tagName, color} = getTagInfo(item.typeCode);
    const isRead = item.isRead;

    const {timeString, dateString} = useMemo(() => {
        const safeDateString = item.createdAt?.endsWith('Z') ? item.createdAt : `${item.createdAt}Z`;
        const dateObj = new Date(safeDateString);

        return {
            timeString: dateObj.toLocaleTimeString('uk-UA', {hour: '2-digit', minute: '2-digit'}),
            dateString: dateObj.toLocaleDateString('uk-UA', {day: '2-digit', month: 'short'}),
        };
    }, [item.createdAt]);

    const parseOptions = {
        replace: (domNode) => {
            if (domNode.name === 'a' && domNode.attribs && domNode.attribs.href) {
                return (
                    <Link
                        to={domNode.attribs.href}
                        className='notification-body-link'
                        onClick={(e) => e.stopPropagation()}
                    >
                        {domToReact(domNode.children)}
                    </Link>
                );
            }
        },
    };

    return (
        <article
            style={{'--item-color': color, '--item-tint': `${color}24`, '--item-wash': `${color}0f`}}
            className={`notification-card${isRead ? ' notification-card-read' : ''}`}
        >
            <div className='notification-card-meta'>
                <span className='notification-card-icon'>
                    <NotificationCategoryIcon category={tagName} />
                </span>
                <div className='notification-card-details'>
                    <span className='notification-card-category'>{tagName || 'Сповіщення'}</span>
                    <span className='notification-card-date'>
                        {dateString} · {timeString}
                    </span>
                </div>
                {!isRead && (
                    <button
                        type='button'
                        className='notification-card-read-button'
                        aria-label='Позначити як прочитане'
                        title='Позначити як прочитане'
                        onClick={() => onMarkAsRead(item.id)}
                    >
                        <CheckOutlined aria-hidden />
                    </button>
                )}
            </div>
            <h3 className='notification-card-title'>{item.title}</h3>
            <div className='notification-card-body'>{item.body ? parse(item.body, parseOptions) : ''}</div>
        </article>
    );
};

export default React.memo(MobileNotificationItem, (prevProps, nextProps) => {
    return prevProps.item.id === nextProps.item.id && prevProps.item.isRead === nextProps.item.isRead;
});
